// Độ dài bài viết
export const POST_LENGTHS = [
  {
    value: "1-2 câu (40-80 ký tự)",
    label: "Siêu ngắn",
  },
  {
    value: "70 - 150 từ",
    label: "Ngắn gọn",
  },
  {
    value: "150 - 250 từ",
    label: "Vừa phải",
  },
  {
    value: "250 - 400 từ",
    label: "Đầy đủ",
  },
  {
    value: "500 - 750 từ",
    label: "Chi tiết",
  },
];

// Độ dài bài viết cho WordPress (blog content)
export const WORDPRESS_POST_LENGTHS = [
  {
    value: "700 từ",
    label: "Ngắn gọn",
  },
  {
    value: "1200 từ",
    label: "Trung bình",
  },
  {
    value: "2000 từ",
    label: "Chi tiết",
  },
];

// Phong cách bài viết
export const POST_STYLES = [
  {
    value: "Chuyên nghiệp",
    label: "Chuyên nghiệp",
  },
  {
    value: "Hài hước",
    label: "Hài hước",
  },
  {
    value: "Sáng tạo",
    label: "Sáng tạo",
  },
  {
    value: "Cảm xúc",
    label: "Cảm xúc",
  },
  {
    value: "Kể chuyện",
    label: "Kể chuyện",
  },
  {
    value: "Quảng cáo",
    label: "Quảng cáo",
  },
  {
    value: "Truyền cảm hứng",
    label: "Truyền cảm hứng",
  },
];

// Default values
export const DEFAULT_POST_LENGTH = POST_LENGTHS[2].value;
export const DEFAULT_POST_STYLES = [POST_STYLES[0].value];

// Loại bài viết (Content Format) cho WordPress
export const CONTENT_FORMAT_OPTIONS = [
  {
    value: "auto",
    label: "🤖 Tự động",
    desc: "AI tự chọn format phù hợp nhất",
  },
  {
    value: "blog",
    label: "📰 Blog",
    desc: "Bài viết blog chuẩn SEO",
  },
  {
    value: "faq",
    label: "❓ FAQ",
    desc: "Câu hỏi thường gặp",
  },
  {
    value: "listicle",
    label: "📋 Listicle",
    desc: "Danh sách Top N...",
  },
  {
    value: "comparison",
    label: "⚖️ So sánh",
    desc: "A vs B, bảng so sánh",
  },
  {
    value: "review",
    label: "⭐ Review",
    desc: "Đánh giá, nhận xét chi tiết",
  },
  {
    value: "howto",
    label: "📘 Hướng dẫn",
    desc: "Step-by-step guide",
  },
  {
    value: "news",
    label: "📢 Tin tức",
    desc: "Tin tức nóng hổi, 5W1H",
  },
];

export const DEFAULT_CONTENT_FORMAT = CONTENT_FORMAT_OPTIONS[0].value;

// Default values cho WordPress
export const DEFAULT_WORDPRESS_POST_LENGTH = WORDPRESS_POST_LENGTHS[1].value; // "Trung bình" (600-1000 từ)
